function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M296,452c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C306,456.48,301.52,452,296,452z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M436,46h-30V30c0-16.542-13.458-30-30-30H136c-16.542,0-30,13.458-30,30v16H76c-16.542,0-30,13.458-30,30 c0,65.057,30.442,112.867,79.828,126.178c16.93,37.265,43.698,68.944,77.674,91.835c7.826,5.273,12.498,14.3,12.498,24.147v55.099 c-6.855,1.758-13.144,5.322-18.281,10.46C190.162,391.277,186,401.32,186,412h-10c-16.542,0-30,13.458-30,30v60 c0,5.523,4.478,10,10,10h200c5.522,0,10-4.477,10-10v-60c0-16.542-13.458-30-30-30h-10c0-18.604-12.767-34.283-30-38.734V318.21 c0-9.879,4.675-18.923,12.508-24.196c33.979-22.893,60.747-54.573,77.676-91.839C435.563,188.859,466,141.052,466,76 C466,59.458,452.542,46,436,46z M66,76c0-5.514,4.486-10,10-10h30v44.7c0,22.795,3.453,45.117,10.27,66.614 C84.447,161.551,66,125.146,66,76z M336,432c5.514,0,10,4.486,10,10v50H166v-50c0-5.514,4.486-10,10-10H336z M386,110.7 c0,27.316-5.438,53.896-16.166,79c-15.26,35.717-40.33,66.052-72.498,87.725C283.976,286.418,276,301.665,276,318.21V382 c0,5.523,4.478,10,10,10c11.028,0,20,8.972,20,20H206c0-5.338,2.082-10.359,5.861-14.139c3.594-3.594,8.311-5.652,13.355-5.846 c0.259,0.02,0.52,0.03,0.783,0.03c5.522,0,10-4.522,10-10.045v-63.84c0-16.51-7.971-31.737-21.322-40.733 c-32.171-21.674-57.241-52.009-72.503-87.729C131.442,164.603,126,138.024,126,110.7V30c0-5.514,4.486-10,10-10h240 c5.514,0,10,4.486,10,10V110.7z M395.734,177.312C402.548,155.81,406,133.489,406,110.7V66h30c5.514,0,10,4.486,10,10 C446,125.143,427.555,161.547,395.734,177.312z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M335.139,118.16c-1.175-3.621-4.305-6.26-8.073-6.806l-43.156-6.264l-19.303-39.115c-1.685-3.414-5.161-5.575-8.968-5.575 c-3.807,0-7.283,2.161-8.968,5.575l-19.303,39.115l-43.155,6.264c-3.768,0.547-6.897,3.186-8.074,6.806 c-1.176,3.621-0.195,7.595,2.531,10.252l31.234,30.44l-7.372,42.987c-0.643,3.752,0.899,7.543,3.979,9.781 c3.08,2.237,7.163,2.532,10.531,0.761l38.598-20.293l38.607,20.293c3.39,1.782,7.471,1.462,10.531-0.762 c3.079-2.238,4.621-6.03,3.977-9.782l-7.38-42.986l31.233-30.439C335.335,125.755,336.315,121.781,335.139,118.16z  M283.65,148.198c-2.357,2.298-3.434,5.609-2.876,8.854l4.841,28.197l-25.323-13.311c-2.915-1.531-6.395-1.531-9.306,0.001 l-25.315,13.31l4.836-28.199c0.556-3.245-0.52-6.555-2.877-8.852l-20.484-19.964l28.301-4.108 c3.258-0.473,6.074-2.519,7.531-5.471l12.662-25.659l12.662,25.659c1.457,2.952,4.273,4.998,7.531,5.471l28.302,4.108 L283.65,148.198z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M256,452h-40c-5.522,0-10,4.477-10,10s4.478,10,10,10h40c5.522,0,10-4.477,10-10S261.522,452,256,452z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M410.01,482h5.575C412.745,481.437,410.835,481.381,410.01,482z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var SvgTournament = function SvgTournament(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTournament, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tournament.53102938.svg";
export { ForwardRef as ReactComponent };